import { useTranslation } from 'i18n';
import { Box, Container, Grid, Stack, Typography, useBreakpoint } from 'ui';

import { FormContainer, MessageContainer } from './styles';

export const AuthLayout = ({
  children,
  title,
  subtitle,
  logo,
}: {
  title: string;
  subtitle: string;
  children: React.ReactNode;
  logo: string;
}) => {
  const { isMobile } = useBreakpoint();
  const { t } = useTranslation('common');

  return (
    <Container>
      <Grid
        container
        sx={{
          height: isMobile ? 'auto' : '100dvh',
          mt: isMobile ? 2 : 0,
          alignItems: 'center',
        }}
      >
        <Grid
          size={{
            md: 6,
            xs: 12,
          }}
        >
          <MessageContainer isMobile={isMobile}>
            <Typography variant="h3" gutterBottom fontWeight="bold">
              {title}
            </Typography>
            <Typography variant="body1">{subtitle}</Typography>
          </MessageContainer>
        </Grid>
        <Grid
          size={{
            md: 6,
            xs: 12,
          }}
          sx={{
            height: isMobile ? 'auto' : '100%',
          }}
        >
          <FormContainer isMobile={isMobile}>
            <Stack
              direction="column"
              sx={{
                width: '100%',
                gap: 1,
              }}
            >
              <Box
                sx={{
                  mb: 4,
                }}
              >
                <img src={logo} alt={t('brand.logoAlt')} width="80px" />
              </Box>
              {children}
            </Stack>
          </FormContainer>
        </Grid>
      </Grid>
    </Container>
  );
};
